import InfoTooltip from "components/Popup/InfoTooltip";
import { IStockOutputFinancials } from "Dashboard/scenes/Projects/domain/IStockOutputFinancials";
import { FormatDateShort } from "utils/dateUtils";
import { FormatNumber, FormatNumberWithUnitOrNull } from "utils/numberUtils";

interface IProps {
  data: IStockOutputFinancials | undefined;
}

const Stock = ({ data }: IProps) => {
  return (
    <div>
      <h3><strong>LAGER</strong></h3>
      <section>
        <div className="buildings-box-header lager-box">
          <div>
            <span className="right-align">suma</span>
            <span className="strong-txt center-align txt-underline">
              {FormatNumberWithUnitOrNull(data?.costAmount, "rsd")}
            </span>
          </div>
          <div>
            <span className="right-align">xxx</span>
            <span className="strong-txt center-align txt-underline">
              {FormatNumberWithUnitOrNull(data?.costAmountXxx, "rsd")}
            </span>
          </div>
        </div>
        <div className="buildings-box-content">
          <div className="list-wrapp">
            {data?.entries &&
              data.entries.map((entry, index) => (
                <article key={index}>
                  <div className="col-1">
                    <span className="left strong">{entry.itemName}</span>
                  </div>
                  <div>
                    <span className="box-span right">
                      {entry.quantityAmount} {entry.quantityUnit.name}
                    </span>
                    <span className="light-color">Izdato</span>
                    <span className="box-span">
                      {FormatDateShort(entry.date)}
                    </span>
                  </div>
                  <div>
                    <span className="box-span right">
                      {FormatNumber(entry.pricePerUnit)} rsd
                    </span>
                    <InfoTooltip
                      tooltip={entry.note}
                      classesProp="light-color grid-span-2 bg-text-overflow"
                      element="span"
                    >
                      cena &nbsp;&nbsp; {entry.note}
                    </InfoTooltip>
                  </div>
                </article>
              ))}
          </div>
        </div>
      </section>
    </div>
  );
};

export default Stock;
